export enum DatoCmsCategoryId {
  KOVINARSKI = 'VwIZ0JC_SFqrvi2jBboWrQ',
  GRADBENI = 'HcywwQbkT_iWN2a_U4wSHA',
  LESNI = 'SQ9jlmleTuuRcKyONdyU-Q'
}
